// extracted by mini-css-extract-plugin
export default {"filter-label":"CommonStyle_filter-label__ee2Bs"};